import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useTabStripRegistration from 'hooks/useTabStripRegistration';
import FontIcon from 'components/FontIcon';
import classes from './SelectB.module.scss';

const {
  arrayOf,
  func,
  number,
  string,
  shape,
} = PropTypes;

const SelectB = (props) => {
  const {
    tabs = [],
    selectedIndex,
    handleClick,
    identifier = '',
  } = props;

  const [collapsed, setCollapsed] = useState(selectedIndex === -1 || (!selectedIndex && selectedIndex !== 0));

  const {
    registrationError,
  } = useTabStripRegistration({ identifier, className: '.k-tab-strip' });

  const tab = ({ title, color } = {}, index = 0) => ( // eslint-disable-line react/prop-types
    <button
      type='button'
      key={index}
      className={classNames(
        classes.tab,
        `bg-${color}`,
        { [classes.active]: (index === selectedIndex) },
      )}
      onClick={() => {
        setCollapsed(!collapsed);
        handleClick(!collapsed ? -1 : index);
      }}
      aria-label={title}
    >
      <div className={classes.tabTitle}>
        <span dangerouslySetInnerHTML={{ __html: title }} />
        <FontIcon icon={collapsed ? 'fa fa-caret-down' : 'fa fa-caret-up'} className={classes.caret} />
      </div>
    </button>
  );

  return registrationError || (tabs.length > 0 &&
    <div id={`TabStrip-${`${identifier ? `${identifier}-` : ''}select`}`}>
      <div className={classes.contentContainer}>
        <div className={classes.tabs}>
          {tab(tabs[0])}
        </div>
      </div>
    </div>);
};

SelectB.propTypes = {
  /**
    Array of tab objects { type, title, color }
  */
  tabs: arrayOf(shape({
    type: string,
    title: string,
    color: string,
  })),
  /**
    Index of selected tab
  */
  selectedIndex: number.isRequired,
  /**
    Click handler method
  */
  handleClick: func,
  /**
    Select handler method
  */
  handleSelect: func,
  /**
    Identifier for component
  */
  indentifier: string,
};

export default SelectB;
